import { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import type { Fetcher, FetcherOptions } from '../types';

/**
 * Wrap an Axios instance to match the Fetcher interface
 */
export default function wrap<T = any>(axios: AxiosInstance): Fetcher<T> {
  return (url: string, options?: FetcherOptions) => {
    const requestConfig: AxiosRequestConfig = {
      ...options,
      data: options?.body
    };

    return axios<T>(url, requestConfig).then(res => res.data);
  };
}
